import React from "react";
import styled from "styled-components";
import { media } from "../styles/Mixin";
import NormalText from "./NormalText";
import Input from "./SearchInput";
import useInput from "../Hooks/useInput";
import { useState } from "react";
import { useMutation } from '@apollo/react-hooks';
import { CREATE_CATEGORY } from '../Queries/createCategory';
import { SEE_REQUESTUSER_CATEGORY } from '../Queries/Category/seeRequestUserCategory';
import { SAVE_TOPCOMMENT } from '../Queries/TopComment/saveTopComment';
import { SEE_REQUESTUSER_TOPCOMMENT } from '../Queries/TopComment/seeRequestUserTopComment';
import { SAVE_RECOMMENT } from '../Queries/ReComment/saveReComment';

const CreateCategory_NeedCheck = ({ setCreateCategoryWindow,comment, setBtnState, setDeleteState  }) => {
  const [saveTopCommentMutation] = useMutation(SAVE_TOPCOMMENT, {
    update(cache, { data: { saveTopComment } }) {
      const { seeRequestUserTopComment } = cache.readQuery({
        query: SEE_REQUESTUSER_TOPCOMMENT,
      });
      cache.writeQuery({
        query: SEE_REQUESTUSER_TOPCOMMENT,
        data: {
          seeRequestUserTopComment: [
            ...seeRequestUserTopComment,
            saveTopComment,
          ],
        },
      });
    },
  });
  const [saveReCommentMutation] = useMutation(SAVE_RECOMMENT);
  const [CraeteCategoryMutation] = useMutation(CREATE_CATEGORY,{
    async update(cache,{data:{createCategory}}){
      const { seeRequestUserCategory } = cache.readQuery({query: SEE_REQUESTUSER_CATEGORY})
      await cache.writeQuery({
        query: SEE_REQUESTUSER_CATEGORY,
        data:{
          seeRequestUserCategory:[...seeRequestUserCategory, createCategory]
        }
      })
      setBtnState(false)
      setDeleteState(false)
    }
  })
  const ctgName = useInput("");
  const [state, setState] = useState(false);
  const createBtn = async () => {
    setState(true);
    if (ctgName.value === "") {
      alert("카테고리명을 입력해주세요 😅");
    } else {
       const { data } = await CraeteCategoryMutation({
         variables: {
           categoryName: ctgName.value,
         },
       });
       if(data){
         const {data: topCommentData} = await saveTopCommentMutation({
           variables:{
             categoryId: data.createCategory.id,
             topCommentId: comment.snippet ? (comment.snippet.topLevelComment.id) :  comment.topCommentId,
             videoId: comment.snippet ? (comment.snippet.topLevelComment.snippet.videoId) : comment.videoId,
             makerChannelId:comment.snippet ? (comment.snippet.topLevelComment.snippet.authorChannelId.value ) : comment.makerChannelId,
             makerChannelDisplayName:comment.snippet ? ( comment.snippet.topLevelComment.snippet.authorDisplayName ) : comment.makerChannelDisplayName,
             makerChannelProfileImageUrl: comment.snippet ? ( comment.snippet.topLevelComment.snippet.authorProfileImageUrl ) : comment.makerChannelProfileImageUrl,
             makerUpdatedAt: comment.snippet ? (new Date(comment.snippet.topLevelComment.snippet.updatedAt)) :new Date(comment.makerUpdatedAt),
             makerPublishedAt: comment.snippet ?  new Date(comment.snippet.topLevelComment.snippet.publishedAt): new Date(comment.makerPublishedAt),
             textOriginal:comment.snippet ? comment.snippet.topLevelComment.snippet.textOriginal : comment.textOriginal,
             likeCount: comment.snippet ? comment.snippet.topLevelComment.snippet.likeCount : comment.likeCount,
           }
         });
         if(comment.snippet){
           if(comment.snippet.totalReplyCount > 0){
             comment.replies.comments.map(async(comment)=>{
               await saveReCommentMutation({
                 variables:{
                   reCommentId: comment.id,
                   videoId: comment.snippet.videoId,
                   makerChannelId: comment.snippet.authorChannelId.value,
                   makerChannelDisplayName: comment.snippet.authorDisplayName,
                   makerChannelProfileImageUrl: comment.snippet.authorProfileImageUrl,
                   makerUpdatedAt: new Date(comment.snippet.updatedAt),
                   makerPublishedAt: new Date(comment.snippet.publishedAt),
                   textOriginal: comment.snippet.textOriginal,
                   likeCount: comment.snippet.likeCount,
                   topCommentId: topCommentData.saveTopComment.id
                 }
               })
             })
           }
         }else{
           if (comment.reComment.length > 0) {
             comment.reComment.map(async(comment)=>{
               await saveReCommentMutation({
                   variables:{
                      reCommentId: comment.reCommentId,
                      videoId: comment.videoId,
                      makerChannelId: comment.makerChannelId,
                      makerChannelDisplayName: comment.makerChannelDisplayName,
                      makerChannelProfileImageUrl: comment.makerChannelProfileImageUrl,
                      makerUpdatedAt: new Date(comment.makerUpdatedAt),
                      makerPublishedAt: new Date(comment.makerPublishedAt),
                      textOriginal: comment.textOriginal,
                      likeCount: comment.likeCount,
                      topCommentId: topCommentData.saveTopComment.id
                    }
               });
             });
           }
         }
       }
      
    }
    setCreateCategoryWindow(false);
    setState(false);
    setBtnState(false);
    setDeleteState(false);
  };

  return (
    <Wrapper>
      <Box>
        <Header>
          <NormalText text={"새 카테고리"} />
        </Header>
        <Content>
          <GuidText text={"카테고리명을 입력해주세요 😄"} />
          <CustomInput
            placeholder={"카테고리명"}
            {...ctgName}
            required={true}
          />
        </Content>
        <Footer>
          <CancelBtn
            onClick={() => {
              setCreateCategoryWindow(false);
              setBtnState(false);
              setDeleteState(false);
            }}
            disabled={state}
          >
            <CancelText text={"🙅🏻취소"} />
          </CancelBtn>
          <CreateBtn onClick={createBtn} disabled={state}>
            <CreateText text={"✔️만들기"} />
          </CreateBtn>
        </Footer>
      </Box>
    </Wrapper>
  );
};

export default CreateCategory_NeedCheck;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: white;
  ${media.deskTop`
    width:500px;
    height:450px;
   `}
  ${media.mobile`
        width:100%;
        height:300px;
    `}
`;

const Header = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  top: 0;
  height: 40px;
  border-bottom: ${(props) => props.theme.boxBorder};
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
`;

const GuidText = styled(NormalText)`
  ${media.deskTop`
     font-size:30px;
   `}
  ${media.mobile`
    height:15px;
    `}
    color:grey;
  padding: 20px;
`;

const CustomInput = styled(Input)`
  ${media.deskTop`
     height:40px;
     width:60%;
   `}
  ${media.mobile`
    height:25px;
    width:50%;
    `}
    border-radius:10px;
`;

const Footer = styled.div`
     position:relative;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    bottom:50;
     ${media.deskTop`
     height:50px;
   `}
    ${media.mobile`
    height:40px;
    `}
    border-top:${(props) => props.theme.boxBorder};
    /* padding:10px; */
`;

const CancelBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  background-color: ${(props) =>
    props.disabled === true ? props.theme.unCheckBlack : "red"};
  cursor: pointer;
`;
const CancelText = styled(NormalText)``;

const CreateBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  background-color: ${(props) =>
    props.disabled === true ? props.theme.unCheckBlack : props.theme.blueColor};
  cursor: pointer;
`;

const CreateText = styled(NormalText)``;
